export default {
	messages: {
		de: {
			actions: {
				release: 'Freigeben',
				save: 'Speichern',
				archive: 'Archivieren',
				cancel: 'Abbrechen',
				ok: 'Ok',
				close: 'Schließen',
				yes: 'Ja',
				no: 'Nein',
			},
			messages: {
				saveQuestion: 'Wollen Sie den Eintrag speichern?',
				archiveQuestion: 'Wollen Sie den Eintrag archivieren?',
			},
		},
		en: {
			actions: {
				save: 'Save',
				archive: 'Archive',
				ok: 'Ok',
				cancel: 'Cancel',
				close: 'Close',
				yes: 'Yes',
				no: 'No',
			},
			messages: {
				saveQuestion: 'Are your sure you want to save the item?',
				archiveQuestion: 'Are your sure you want to archive the selected item?',
			},
		},
	},
};
